<template>
  <div class="whole-div-mci">
    <div class="div1-mci">
      公司介绍
    </div>
    <!--    第二层-->
    <div class="div2-mci">
      <div class="div2-div1-mci">
        <br>
        &#12288;&#12288;浙江纵海自动化设备有限公司成立于2015年。公司开发一系列畜禽无害化智能处理机，按照《动物防疫法》《畜禽规模养殖污染防治条例》《病害动物和病害动物产品生物安全处理规程以及国务院兽医主管部门的有关规定，对病死畜禽及其制品主要采取干化法分类进行无害化处理，通过高温裂解，将病原体完全杀灭，并使油脂融化和蛋白质凝固，经化制后的油脂可用于工业用油；肉骨粉可用于有机肥料加工的原材料。
        <br>
        &#12288;&#12288;生产过程中产生的废气，经配套处理后达到国家排放标准，确保无废水、无废气、无废渣，杜绝二次污染源的产生，并达到零排放；保证了畜产品质量的安全及人民群众的身体健康，是畜禽无害化处理的首选产品!
        <br><br>
      </div>
    </div>
    <!--    第三层-->
    <div class="div3-mci">
      <div class="div3-div1-mci" v-for="(item,index) in companyImgList" :key="index">
        <div style="width: 100%">
          <img :src="item.companyImg" alt="" width="100%">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../css/mobile/MCI_MobileCompanyIntroduce.css'

  export default {
    name: "MobileCompanyIntroduce",
    data() {
      return {
        introduceDetails: '',
        companyImgList: [
          {companyImg: require('../../../public/image/公司1.jpg'),},
          {companyImg: require('../../../public/image/公司2.jpg'),},
          {companyImg: require('../../../public/image/公司3.jpg'),},
          {companyImg: require('../../../public/image/公司4.jpg'),},
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/second/MobileCompanyIntroduce.vue